
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import './autocomplete.css';

import { contactsAddNewSupplier } from '../../../redux/actions/contacts';
import { fetchConToken } from '../../../helpers/fetch';
import { toast } from 'react-toastify';

const filter = createFilterOptions();

export const AutocompleteContacts = ({ dataForm, id_proveedor, handleChangeProveedor }) => {

    const dispatch = useDispatch()
    const { listSuppliers } = useSelector(state => state.contacts)

    const handleChange = async (e, newValue) => {

        let proveedor = {
            'id_proveedor': newValue ? newValue.id : null,
        }

        if (newValue && !newValue.id) {

            const values = {
                id: newValue?.id ? newValue.id : null,
                nombre: newValue?.id ? newValue.nombre : newValue.inputValue,
                clasificacion: 'proveedor'
            }

            // Creando nuevo proveedor
            const newContact = values;
            const resp = await fetchConToken('contacts', newContact, 'POST');
            const body = await resp.json();
            if (body.ok) {
                toast.success(body.msg);
                if (newContact.clasificacion === 'proveedor') {
                    dispatch(contactsAddNewSupplier(body.data));
                    proveedor.id_proveedor = body.data.id || null;
                }
            }

        }

        handleChangeProveedor(proveedor);

    }

    return (
        <Autocomplete
            value={listSuppliers.find((it) => (it.id === id_proveedor)) || null}
            onChange={(e, newValue) => handleChange(e, newValue)}
            disabled={dataForm.reading_mode}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;

                // Suggest the creation of a new value
                const isExisting = options.some((option) => inputValue === option.nombre);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        nombre: `Crear  "${inputValue}"`,
                    });
                }

                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="free-solo-with-text-demo"
            options={listSuppliers}
            getOptionLabel={(option) => {

                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }

                // Add "xxx" option created dynamically
                if (option.inputValue) {
                    return option.inputValue;
                }

                // Regular option
                return option.nombre;
            }}
            renderOption={(props, option) => <li {...props}>{option.nombre}</li>}
            sx={{ width: '100%' }}
            size='small'
            freeSolo
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Proveedor"
                    placeholder='Ingrese nombre del proveedor'
                />
            )}
        />
    );
}